<template>
  <v-flex>
    <v-data-table
      v-model="relatedProducts"
      :loading="loading"
      :headers="headers"
      :items="products"
      :rows-per-page-text="$t('Rows per page')"
      :pagination.sync="pagination"
      :total-items="total"
      show-select
      select-all
      class="elevation-1"
      item-key="id"
    >
      <v-progress-linear
        slot="progress"
        color="primary"
        indeterminate
      />

      <template v-slot:items="props">
        <tr class="v-datatable__row">
          <td class="text-xs-left">
            <v-checkbox
              v-model="props.selected"
              hide-details
            />
          </td>
          <td>{{ props.item.sku }}</td>
          <td>{{ props.item.name }}</td>
        </tr>
      </template>
      <template v-slot:pageText="props">
        <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import ProductService from '@/modules/Products/service'

export default {
  name: 'ProductSingleRelatedProducts',

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'created_at'
      },
      total: 0,
      loading: false,
      products: []
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('SKU'), value: 'sku' },
        { text: this.$t('Name'), value: 'name' }
      ]
    },
    relatedProducts: {
      get: function () {
        return this.products.filter(product => this.product.related.products.includes(product.id))
      },
      set: function (products) {
        this.product.related.products = products.map(product => product.id)
      }
    }
  },

  watch: {
    pagination: function () {
      this.getProducts()
    }
  },

  methods: {
    async getProducts () {
      this.loading = true
      const res = await ProductService.loadOnlyProducts(this.pagination)
      this.products = res.collection
      this.total = res.page.total
      this.loading = false
    }
  }
}
</script>
